export const FORM_TYPES = {
  PAGE_FORM: 'PageForm',
  OFFER_FORM: 'OfferForm',
};